/** Sync live banking API accounts → localStorage for treasury/caisse auto mode. */

export const BANQUE_ACCOUNTS_TREASURY_SYNC_EVENT = 'BANQUE_ACCOUNTS_TREASURY_SYNC';

export function mapBankAccountForTreasury(account) {
  if (!account || typeof account !== 'object') return null;
  const bankName = account.bank_name || account.bankName || account.bank || '';
  const name = account.account_name || account.name || account.description || '';
  const statusRaw = account.status || (account.active ? 'active' : 'inactive');
  return {
    id: account.id,
    type: 'banque',
    name,
    accountNumber: account.account_number || account.accountNumber || '',
    balance: parseFloat(account.balance ?? account.bankBalance ?? 0) || 0,
    bank: bankName,
    status: String(statusRaw).toLowerCase() === 'active' || statusRaw === 'Active' ? 'active' : statusRaw,
    notes: account.notes || '',
  };
}

/** Normalize API account list and sync treasury/caisse listeners. */
export function normalizeAndSyncBankAccounts(raw) {
  const accounts = Array.isArray(raw) ? raw : [];
  syncBanqueAccountsForTreasury(accounts);
  return accounts;
}

/** Persist mapped accounts for treasury pages and notify listeners. */
export function syncBanqueAccountsForTreasury(accounts = []) {
  try {
    const mapped = (accounts || []).map(mapBankAccountForTreasury).filter(Boolean);
    localStorage.setItem('banqueAccounts', JSON.stringify(mapped));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(BANQUE_ACCOUNTS_TREASURY_SYNC_EVENT, { detail: { accounts: mapped } }));
    }
  } catch (error) {
    console.warn('[banque] treasury sync failed:', error);
  }
}
